import React, {useEffect, useState} from 'react';
import 'datatables.net';
import 'datatables.net-responsive';
import $ from "jquery";
import cogoToast from "cogo-toast";
import {GET_COLLECTION_AGGREGATE_DATA} from "../../api";
import {company, employer, getPreSignedUrl, uploadPhoto} from "../../api/app";
import generateChar from "../../utils/generateChar";
import moment from "moment/moment";
import {capitalize} from "../../utils/capitalize";
const Buffer = require('buffer/').Buffer;

let searchableFields = [
    { field: 'name', isNumeric: false },
    { field: 'email', isNumeric: false }
]

let company_id = null;

let filter = {};

const Company = () => {

    document.title = "Organization";

    const token = localStorage.getItem('jwtToken');

    const [stateReady, setStateReady] = useState(false);
    const [editForm, setEditForm] = useState(false);
    const [editId, setEditId] = useState(0);
    const [cover_image, set_cover_image] = useState(null);

    useEffect(() => {
        let table = $('#td-company').DataTable({
            responsive: true,
            "language": {
                "processing": '<div class="spinner-border"></div><p class="mg-t-10 tx-12">Collecting Organization Report</p>'
            },
            searching: true,
            lengthMenu: [[10], [10]],
            ordering: false,
            info: true,
            bFilter: false,
            processing: true,
            pageLength: 10,
            serverSide: true,
            ajax: function(data, callback) {
                // make a regular ajax request using data.start and data.length
                $.ajax(GET_COLLECTION_AGGREGATE_DATA, {
                    type: 'POST',
                    headers: {
                        "Authorization": token
                    },
                    data: {
                        query: $('.dataTables_filter input').val(),
                        collection: "company",
                        filter,
                        searchableFields,
                        pageSize: data.start,
                        format: 'json',
                        sort: { _id: -1 },
                        pageIndex: (data.length + data.start) / data.length
                    },
                    success: function (res) {
                        let array = [];
                        res.data.map((data) => {
                            array.push({raw: data})
                        });
                        callback({
                            recordsTotal: res.total,
                            recordsFiltered: res.total,
                            data: array
                        });
                    },
                    error: function(err) {
                        cogoToast.error( err.responseJSON['error'].details !== undefined ? err.responseJSON['error'].details[0].message : err.responseJSON['error'], {position: "top-right", hideAfter: 5});
                    }
                });
            },
            "columns": [
                {
                    className: 'dt-control',
                    orderable: false,
                    data: null,
                    defaultContent: '',
                },
                {"data": "raw"},
                {"data": "raw"},
                {"data": "raw"},
                {"data": "raw"}
            ],
            "columnDefs": [
                {
                    "render": function () {
                        return null;
                    },
                    "targets": 0
                },
                {
                    "render": function (data) {
                        return data.name;
                    },
                    "targets": 1
                },
                {
                    "render": function (data) {
                        return capitalize(data?.type) || "Company";
                    },
                    "targets": 2
                },
                {
                    "render": function (data) {
                        return moment(data.createdAt).format("Do MMM, YYYY");
                    },
                    "targets": 3
                },
                {
                    "render": function () {
                        return `<nav class="nav nav-icon-only"><a href="#" class="nav-link edit_company"><i class="fa fa-pencil"></i> Edit</a> <a href="#" class="nav-link delete_company"><i class="fa fa-trash-alt"></i> Delete</a><a href="#" class="nav-link create-employer"><i class="fa fa-plus"></i> Approve Partner</a></nav>`
                    },
                    "targets": 4
                }
            ]
        });

        table.on('click', '.delete_company', function(e) {
            e.preventDefault();
            let extract_td = table.row($(this).closest('tr')).data();

            $(".data-message").text(`Are you sure, you want to delete this company?`);
            $('#delete-data').unbind("click").click(function(){

                $("#modalConfirm").modal("hide");
                $(".modal-backdrop").remove();

                const options = {
                    position: "top-right",
                    hideAfter: 0
                };

                let {hide} = cogoToast.loading('Please wait... contacting to server.', options);

                let data = {
                    id: extract_td.raw._id,
                }

                company("delete", data).then((result) => {
                    hide();
                    if(!result.error) {
                        reloadTable();
                        cogoToast.success("Company successfully removed.", {position: "top-right"});
                    }
                });
            });

            $("#modalConfirm").modal({ backdrop: 'static', focus: false, show: true });
        });

        table.on('click', '.create-employer', function(e) {
            e.preventDefault();
            let extract_td = table.row($(this).closest('tr')).data();

            setEditForm(false);
            company_id = extract_td.raw._id;

            $('#admin_form').parsley();
            $("#company-name").val(extract_td.raw.name);
            $("#contact-person").val(extract_td.raw.meta?.contact_person);
            $("#company-email").val(extract_td.raw.meta?.email);
            $("#modalUser").modal("show");
        });

        table.on('click', '.edit_company', function(e) {
            e.preventDefault();
            let extract_td = table.row($(this).closest('tr')).data();

            setEditForm(true);
            $('#name').prop("required", true);
            $('#description').prop("required", false);
            $('#type').prop("required", false);
            $('#image').prop("required", false);

            setEditId(extract_td.raw._id);
            $("#name").val(extract_td.raw.name);
            $("#description").val(extract_td.raw.bio);
            $("#email").val(extract_td.raw.meta?.email);
            $("#type").val(extract_td.raw?.type || "company");
            $("#link").val(extract_td.raw?.website)

            $('#company_form').parsley();

            $("#modalCompany").modal("show");

            return false;
        });

        $('#td-company tbody').on('click', 'td.dt-control', function () {
            let tr = $(this).closest('tr');
            let row = table.row(tr);

            if (row.child.isShown()) {
                // This row is already open - close it
                row.child.hide();
                tr.removeClass('shown');
            } else {
                // Open this row
                row.child(format(row.data())).show();
                tr.addClass('shown');
            }
        });

        function format(d) {
            // `d` is the original data object for the row
            return (
                '<table cellpadding="5" cellspacing="0" border="0" style="padding-left:50px;">' +
                '<tr>' +
                '<td>Description:</td>' +
                '<td>' +
                `${d.raw?.bio}` +
                '</td>' +
                '</tr>' +
                '<tr>' +
                '<td>Position:</td>' +
                '<td>' +
                `${d.raw.meta?.contact_position || "N/A"}` +
                '</td>' +
                '</tr>' +
                '<td>Contact Number:</td>' +
                '<td>' +
                `${d.raw.meta?.contact_number || "N/A"}` +
                '</td>' +
                '</tr>' +
                '<td>Contact Person:</td>' +
                '<td>' +
                `${d.raw.meta?.contact_person || "N/A"}` +
                '</td>' +
                '</tr>' +
                '<tr>' +
                '<td>Date:</td>' +
                '<td>' +
                `${moment(d.raw?.createdAt).format("Do MMM, YYYY HH:mm")}` +
                '</td>' +
                '</tr>' +
                '</table>'
            );
        }

        return () => {
            table.destroy();
            filter = {};
            company_id = null;
        }

    }, []);

    const reloadTable = () => {
        $('#td-company').DataTable().ajax.reload(null, false);
    };

    const clearForm = () => {
        $('#name').val(null);
        $('#description').val(null);
        $('#email').val(null);
        $('#image').val(null);
        $('#link').val(null);
        set_cover_image(null);
        $('#company_form').parsley().destroy();
    }

    const handleShowModal = () => {
        setEditForm(false);
        $('#modalCompany').modal({backdrop: 'static', keyboard: false});
        $('#company_form').parsley();
        $("#modalCompany").modal("show");
    }

    const handleAddCompany = async(e) => {
        e.preventDefault();
        setStateReady(true);

        let name = $('#name').val();
        let bio = $('#description').val();
        let type = $('#type').val();
        let email = $('#email').val();
        let website = $('#link').val();
        let slug = $('#slug').val();

        let data = {
            name,
            bio,
            email,
            type,
            website,
            slug,
            logo: cover_image !== null ? await S3Upload() : null
        };

        if(editForm) {
            company("put", Object.assign(data, {id: editId, action: "update"})).then((result) => {
                setStateReady(false);

                if(!result.error) {
                    cogoToast.success("Data successfully updated.", {position: "top-right", hideAfter: 5});
                    resetForm("modalCompany", "company_form");
                    reloadTable();
                }
            });

            return false;
        }

        company("post", data).then((result) => {
            setStateReady(false);
            if(!result.error) {
                cogoToast.success("Data successfully created.", {position: "top-right", hideAfter: 5});
                resetForm("modalCompany", "company_form");
                reloadTable();
            }
        });
    }

    const handleFileUpload = (event) => {
        if(event.target.files[0] !== undefined && $('#image').parsley().isValid() !== false) {
            let reader = new FileReader();
            reader.readAsDataURL(event.target.files[0]);
            reader.onload = () => {
                set_cover_image(reader.result);
            };
            reader.onerror = () => {
                set_cover_image(null);
            };
        }
    }

    const S3Upload = () => {
        return getPreSignedUrl().then(async (response) => {
            if (response.error) {
                return false;
            }

            const config = {
                headers: {
                    'Content-Type': 'image/jpeg; charset=utf-8',
                    'x-amz-acl': 'public-read'
                }
            };

            const buffer = new Buffer.from(cover_image.replace(/^data:image\/\w+;base64,/, ""), 'base64')

            return uploadPhoto(response.payload.url, buffer, config).then((result) => {
                if (!result.error) {
                    return result.payload.url.replace(/\?.*$/g,"");
                }

                return null;
            });
        })
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        let name = $('#contact-person').val();
        let email = $('#company-email').val();
        let password = $('#password').val();

        setStateReady(true);

        let data = {
            name,
            email,
            password,
            company: company_id
        };

        employer("post", data).then((result) => {
            setStateReady(false);
            if(!result.error) {
                cogoToast.success("Employer successfully created.", {position: "top-right", hideAfter: 5});
                resetForm("modalUser", "admin_form");
                reloadTable();
            }
        });
    };

    const handleStatusChange = (data, text) => {
        const status = $("#tx-status");
        const dt_company = $('#td-company');
        if(data === "all") {
            status.text("Select Status");
            if (filter.hasOwnProperty("status")) {
                delete filter["status"];
                dt_company.DataTable().ajax.reload();
            }
            return false;
        }

        filter = Object.assign(filter, {status: data});
        status.text(text);
        dt_company.DataTable().ajax.reload();
    }

    const resetForm = (id, form) => {
        const parsley = $(`#${form}`).parsley();
        $(':input',`#${form}`)
            .not(':button, :submit, :reset, :hidden')
            .val('')
            .prop('checked', false)
            .prop('selected', false);
        $(`#${id}`).modal("hide");
        parsley.reset();
        parsley.destroy();
        $(".modal-backdrop").remove();
    };

    return (
        <div className="content-body">
            <div className="container-fluid pd-x-0">
                <div className="d-sm-flex align-items-center justify-content-between mg-b-20 mg-lg-b-25 mg-xl-b-30">
                    <div>
                        <nav aria-label="breadcrumb">
                            <ol className="breadcrumb breadcrumb-style1 mg-b-10">
                                <li className="breadcrumb-item active" aria-current="page">Organization</li>
                            </ol>
                        </nav>
                        <h4 className="mg-b-0 tx-spacing--1">Organization</h4>
                    </div>
                    <div className="d-none d-md-block">
                        <button className="btn btn-sm pd-x-15 btn-primary btn-uppercase mg-l-5 outline-none" onClick={handleShowModal.bind()}><i className="wd-10 mg-r-5 fa fa-plus"></i> Add New</button>
                    </div>
                </div>

                <div className="row row-xs">
                    <div className="col-md-12 mg-t-10">
                        <div className="card">
                            <div className="card-header d-flex align-items-center justify-content-between">
                                <h6 className="mg-b-0">Organization List</h6>
                                <div className="d-flex tx-18 align-items-center">
                                    <div className="dropdown mg-r-10">
                                        <a href="javascript:void(0)" className="tx-13 link-03 mg-l-5 pd-0-f outline-none dropdown-toggle" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"><span id="tx-status">Select Status</span></a>
                                        <div className="dropdown-menu" aria-labelledby="dropdownMenuButton">
                                            <a className="dropdown-item" href="javascript:void(0)" onClick={handleStatusChange.bind(null, 'all')}>All</a>
                                            <a className="dropdown-item" href="javascript:void(0)" onClick={handleStatusChange.bind(null, "pending", "Pending")}>Pending</a>
                                        </div>
                                    </div>
                                    <a href="#" onClick={(e) => {e.preventDefault(); $('#td-company').DataTable().ajax.reload()}} className="link-03 lh-0"><i className="icon ion-md-refresh"></i></a>
                                </div>
                            </div>
                            <div className="card-body">
                                <table id="td-company" className="table">
                                    <thead>
                                    <tr>
                                        <th></th>
                                        <th className="wd-25p">Name</th>
                                        <th className="wd-25p">Type</th>
                                        <th className="wd-25p">Date</th>
                                        <th className="wd-25p">Action</th>
                                    </tr>
                                    </thead>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="modal fade" id="modalCompany" role="dialog" aria-hidden="true">
                    <div className="modal-dialog modal-lg modal-dialog-centered wd-sm-650" role="document">
                        <div className="modal-content">
                            <div className="modal-header pd-y-20 pd-x-20 pd-sm-x-30">
                                <div className="media align-items-center">
                                    <div className="media-body">
                                        <a href="" role="button" className="close pos-absolute t-15 r-15" data-dismiss="modal" aria-label="Close" onClick={clearForm.bind()}>
                                            <span aria-hidden="true">&times;</span>
                                        </a>
                                        <h4 className="tx-18 tx-sm-20 mg-b-2">Organization</h4>
                                    </div>
                                </div>
                            </div>
                            <div className="modal-body pd-sm-t-30 pd-sm-b-40 pd-sm-x-30">
                                <form id="company_form" className="parsley-style-1" onSubmit={handleAddCompany.bind()}>
                                    <div id="nameWrapper" className="form-group parsley-input">
                                        <label className="tx-10 tx-uppercase tx-medium tx-spacing-1 mg-b-5">Organization Name<span className="tx-danger">*</span></label>
                                        <input id="name" type="text" className="form-control"
                                               placeholder="Enter organization name"
                                               autoComplete="none"
                                               data-parsley-class-handler="#nameWrapper"
                                               required
                                        />
                                    </div>

                                    <div id="typeWrapper" className="form-group parsley-input">
                                        <label>Type<span className="tx-danger">*</span></label>
                                        <select className="custom-select" id="type" required>
                                            <option value="" disabled selected>Select Type</option>
                                            <option value="company">Company</option>
                                            <option value="ngo">NGO</option>
                                            <option value="embassy">Embassy/High Commissioner</option>
                                            <option value="ministry">Ministry(GRZ)</option>
                                            <option value="investor">Investor</option>
                                        </select>
                                    </div>

                                    <div id="emailWrapper" className="form-group parsley-input">
                                        <label className="tx-10 tx-uppercase tx-medium tx-spacing-1 mg-b-5">Email (Optional)</label>
                                        <input id="email" type="email" className="form-control"
                                               placeholder="Enter website link"
                                               autoComplete="none"
                                               data-parsley-class-handler="#emailWrapper"
                                        />
                                    </div>

                                    <div className="form-group">
                                        <label className="tx-10 tx-uppercase tx-medium tx-spacing-1 mg-b-5">Upload Logo</label>
                                        <input id="image" type="file" className="form-control"
                                               onChange={handleFileUpload.bind()}
                                               data-parsley-filemaxmegabytes="1"
                                               data-parsley-trigger="change"
                                               data-parsley-filemimetypes="image/jpeg, image/jpg, image/png"
                                               accept="image/jpeg, image/jpg, image/png"
                                        />
                                    </div>

                                    <div id="descriptionWrapper" className="form-group parsley-input">
                                        <label className="tx-10 tx-uppercase tx-medium tx-spacing-1 mg-b-5">Description<span className="tx-danger">*</span></label>
                                        <textarea id="description" rows="5" className="form-control"
                                                  placeholder="Provide a description"
                                                  data-parsley-class-handler="#descriptionWrapper" required/>
                                    </div>

                                    <div id="linkWrapper" className="form-group parsley-input">
                                        <label className="tx-10 tx-uppercase tx-medium tx-spacing-1 mg-b-5">Website Link</label>
                                        <input id="link" type="url" className="form-control"
                                               placeholder="Enter website link"
                                               autoComplete="none"
                                               data-parsley-class-handler="#linkWrapper"
                                        />
                                    </div>

                                    <div id="slugWrapper" className="form-group parsley-input">
                                        <label className="tx-10 tx-uppercase tx-medium tx-spacing-1 mg-b-5">Slug</label>
                                        <input id="slug" type="text" className="form-control"
                                               placeholder="Enter slug name"
                                               autoComplete="none"
                                               data-parsley-class-handler="#slugWrapper"
                                        />
                                    </div>

                                    {stateReady ? <button disabled className="btn btn-success btn-block"><span
                                        className="spinner-border spinner-border-sm mg-r-10" role="status"
                                        aria-hidden="true"/><span id="status">Please Wait</span></button> : editForm ?
                                        <button className="btn btn-success btn-block">Update Organization</button> :
                                        <button className="btn btn-success btn-block">Create Organization</button>}
                                </form>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="modal fade" id="modalUser" tabIndex="-1" role="dialog" aria-hidden="true">
                    <div className="modal-dialog modal-dialog-centered" role="document">
                        <div className="modal-content">
                            <div className="modal-header pd-y-20 pd-x-20 pd-sm-x-30">
                                <a href="#" role="button" className="close pos-absolute t-15 r-15" data-dismiss="modal" aria-label="Close">
                                    <span aria-hidden="true">&times;</span>
                                </a>
                                <div className="media-body"><a href="#" role="button" className="close pos-absolute t-15 r-15" data-dismiss="modal" onClick={resetForm.bind(null, "modalUser", "admin_form")} aria-label="Close"><span aria-hidden="true">×</span></a><h4 className="tx-18 tx-sm-20 mg-b-2">{editForm ? "Edit Partner" : "Create Partner"}</h4><p className="tx-13 tx-color-02 mg-b-0">{editForm ? "Edit" : "Create"} partner to have access to the console</p></div>
                            </div>
                            <div className="modal-body pd-sm-t-30 pd-sm-b-40 pd-sm-x-30">
                                <form id="admin_form" className="parsley-style-1" onSubmit={handleSubmit.bind()}>
                                    <div id="companyWrapper" className="form-group parsley-input">
                                        <label>Company<span className="tx-danger">*</span></label>
                                        <input id="company-name" type="text" className="form-control"
                                               placeholder="Enter company name"
                                               autoComplete="none"
                                               data-parsley-class-handler="#nameWrapper" disabled/>
                                    </div>

                                    <div id="nameWrapper" className="form-group parsley-input">
                                        <label>Full Name<span className="tx-danger">*</span></label>
                                        <input id="contact-person" type="text" className="form-control"
                                               placeholder="Enter full name"
                                               autoComplete="none"
                                               data-parsley-class-handler="#nameWrapper" required/>
                                    </div>

                                    <div id="emailWrapper" className="form-group parsley-input">
                                        <label>Email Address<span className="tx-danger">*</span></label>
                                        <input id="company-email" type="email" className="form-control"
                                               placeholder="Enter valid email address"
                                               autoComplete="none"
                                               data-parsley-class-handler="#emailWrapper"
                                               required
                                        />
                                    </div>

                                    <div id="passwordWrapper" className="form-group parsley-input">
                                        <div className="d-flex justify-content-between">
                                            <label>Password<span className="tx-danger">*</span></label>
                                            <a href="javascript:void(0)" onClick={() => $("#password").val(generateChar(7))} className="link-01">Generate</a>
                                        </div>
                                        <input id="password" type="text" className="form-control"
                                               placeholder="Enter new password"
                                               autoComplete="none"
                                               data-parsley-class-handler="#passwordWrapper"
                                               required
                                        />
                                    </div>

                                    {stateReady ? <button disabled className="btn btn-primary btn-block"><span className="spinner-border spinner-border-sm mg-r-10" role="status" aria-hidden="true"/>Please Wait</button> : editForm ? <button className="btn btn-primary btn-block">Update Account</button> : <button className="btn btn-primary btn-block">Create Account</button>}
                                </form>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="modal fade" id="modalConfirm" tabIndex="-1" role="dialog" aria-labelledby="confirmation"
                     aria-hidden="true">
                    <div className="modal-dialog modal-dialog-centered modal-sm" role="document">
                        <div className="modal-content tx-14">
                            <div className="modal-header">
                                <h6 className="modal-title" id="exampleModalLabel6">Delete Confirm?</h6>
                                <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                                    <span aria-hidden="true">&times;</span>
                                </button>
                            </div>
                            <div className="modal-body">
                                <p className="mg-b-0 data-message">Empty</p>
                            </div>
                            <div className="modal-footer">
                                <button type="button" id="delete-data" className="btn btn-success btn-block">Yes, Delete</button>
                                <button type="button" className="btn btn-danger btn-block mt-0" data-dismiss="modal">Cancel</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
};

export default Company;
